import type { WhatsUpResponse } from '../entities'
import { WhatsUpSchema } from '../entities'
import { getConfig } from '@/tools/config'
import { fetcher } from '@/tools/fetcher/client'

export const whatsUp = async (fields: string): Promise<WhatsUpResponse> => {
  const { apiUrl } = getConfig()
  const response = await fetcher.get(`${apiUrl}/v3/whats_up?fields=${fields}`)
  return WhatsUpSchema.parse(response.data)
}
